import React from 'react';

export const IconCautionYellow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14.001"
    height="14"
    viewBox="0 0 14.001 14"
  >
    <rect
      className="a"
      fill="none"
      width="14"
      height="14"
      transform="translate(0.001)"
    />
    <g transform="translate(-275.125 -70.521)">
      <g transform="translate(275.125 71.321)">
        <path
          className="b"
          fill="#ffd76a"
          d="M514.788,130.922a1.327,1.327,0,0,1-1.144.66H502.287a1.32,1.32,0,0,1-1.144-1.986l5.678-9.832a1.321,1.321,0,0,1,2.284,0l5.678,9.832A1.328,1.328,0,0,1,514.788,130.922Z"
          transform="translate(-500.963 -119.107)"
        />
      </g>
      <path
        className="c"
        fill="#333"
        d="M508.228,130.459a.936.936,0,1,1,.863-.577A.929.929,0,0,1,508.228,130.459Z"
        transform="translate(-226.094 -48.168)"
      />
      <path
        className="c"
        d="M508.221,127.619a.663.663,0,0,1-.656-.607l-.288-3.952a.947.947,0,0,1,.873-1.008.98.98,0,0,1,1.007.943l-.287,4.015a.66.66,0,0,1-.646.608Z"
        transform="translate(-226.093 -47.904)"
      />
    </g>
  </svg>
);

export const IconMfaEnabled = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
  >
    <path
      d="M7.5 0C7.64375 0 7.7875 0.0314219 7.91562 0.0911234L13.8031 2.60173C14.4906 2.89395 15.0031 3.57581 15 4.39906C14.9844 7.5161 13.7094 13.2192 8.32187 15.8115C7.8 16.0628 7.19375 16.0628 6.675 15.8115C1.28751 13.2192 0.0156392 7.51925 1.4214e-05 4.39906C-0.00311078 3.57581 0.509388 2.89395 1.19689 2.60173L7.08125 0.0911234C7.20938 0.0314219 7.35313 0 7.5 0ZM10.3406 5.17204C10.0062 4.92695 9.5375 5.00236 9.29375 5.33857L6.61875 9.03692L5.79063 8.17596C5.50313 7.87746 5.02813 7.86803 4.73125 8.15711C4.43438 8.44619 4.42501 8.9238 4.7125 9.22231L6.1625 10.7306C6.31563 10.8908 6.53125 10.9756 6.75313 10.9599C6.975 10.9442 7.17813 10.8311 7.30938 10.652L10.5062 6.22467C10.75 5.88845 10.675 5.41713 10.3406 5.17204Z"
      fill="#34B445"
    />
  </svg>
);

export const IconMultiplePerson = () => (
  <svg
    id="icon_複数ユーザー"
    xmlns="http://www.w3.org/2000/svg"
    width="18.998"
    height="11"
    viewBox="0 0 18.998 11"
  >
    <g
      id="Group_4683"
      data-name="Group 4683"
      transform="translate(393.8 -120.351)"
    >
      <g id="Group_4681" data-name="Group 4681">
        <path
          id="Path_8033"
          data-name="Path 8033"
          d="M-388.358,126.643a3.3,3.3,0,0,0-.71-.338,2.194,2.194,0,0,0,1.268-1.985,2.2,2.2,0,0,0-2.2-2.2,2.2,2.2,0,0,0-2.2,2.2,2.192,2.192,0,0,0,1.268,1.985A4.773,4.773,0,0,0-393.8,131c0,.118.007.233.014.349h4.139c-.009-.165-.015-.292-.015-.416A7.505,7.505,0,0,1-388.358,126.643Z"
          fill="#666"
        />
      </g>
      <g id="Group_4682" data-name="Group 4682">
        <path
          id="Path_8034"
          data-name="Path 8034"
          d="M-380.244,126.643a3.3,3.3,0,0,1,.71-.338,2.194,2.194,0,0,1-1.268-1.985,2.2,2.2,0,0,1,2.2-2.2,2.2,2.2,0,0,1,2.2,2.2,2.193,2.193,0,0,1-1.269,1.985A4.773,4.773,0,0,1-374.8,131c0,.118-.007.233-.014.349h-4.139c.009-.165.015-.292.015-.416A7.505,7.505,0,0,0-380.244,126.643Z"
          fill="#666"
        />
      </g>
    </g>
    <path
      id="Path_8035"
      data-name="Path 8035"
      d="M-379.785,131.351c.008-.138.016-.276.016-.416,0-2.7-1.457-4.968-3.424-5.6a2.613,2.613,0,0,0,1.512-2.366,2.619,2.619,0,0,0-2.62-2.619,2.619,2.619,0,0,0-2.62,2.619,2.613,2.613,0,0,0,1.512,2.366c-1.967.631-3.424,2.9-3.424,5.6,0,.14.008.278.016.416Z"
      transform="translate(393.8 -120.351)"
      fill="#666"
    />
  </svg>
);
